import "../global.css";
import "./scripts/scripts.js";

import Glide from "@glidejs/glide";
import { animate, scroll, stagger } from "motion";
import { splitText } from "motion-plus";

document.fonts.ready.then(() => {
  const { lines } = splitText(".split-lines", {
    lineClass:
      "bg-primary inline-flex text-primary-foreground py-2 px-4 lg:py-4 lg:px-7 rounded-lg mt-3",
  });
});

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".js-kato-fast-carousel").forEach((carousel) => {
    new Glide(carousel, {
      type: "carousel",
      perView: 1,
      gap: 0,
      autoHeight: true,
    }).mount();
  });
});
